export default {
  passCard: () => import('@/league/components/main/PassComponent.vue'),
  passTable: () => import('@/components/base-components/Packages/PassTable.vue'),
};
